import moment from "moment";

export default moment;
